module.exports = __webpack_public_path__ + "794042437876775673dbeaf021935035.svg";